import { Directive, EventEmitter, HostBinding, HostListener, Output } from '@angular/core'

@Directive({
  selector: '[ngxDragNDrop]',
  standalone: true
})
export class DragNDropDirective {
  constructor() {}

  @HostBinding('class.fileOver') fileOver: boolean
  @Output() fileDropped: EventEmitter<File> = new EventEmitter<File>()
  @Output() uploadStatus: EventEmitter<string> = new EventEmitter<string>()

  @HostListener('dragover', ['$event'])
  onDragOver(event: DragEvent) {
    event.preventDefault()
    event.stopPropagation()
    this.fileOver = true
    this.uploadStatus.emit('Drop Here')
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(event: DragEvent) {
    if (
      (event.target as HTMLElement).classList.contains('upload-state') ||
      (event.target as HTMLElement).classList.contains('upload-container') ||
      (event['fromElement'] as HTMLElement).classList.contains('upload-state') ||
      (event['fromElement'] as HTMLElement).classList.contains('upload-container') ||
      (event['relatedTarget'] as HTMLElement).classList.contains('upload-state') ||
      (event['relatedTarget'] as HTMLElement).classList.contains('upload-container') ||
      (event['srcElement'] as HTMLElement).classList.contains('upload-state') ||
      (event['srcElement'] as HTMLElement).classList.contains('upload-container')
    )
      return

    event.preventDefault()
    event.stopPropagation()
    this.fileOver = false
    this.uploadStatus.emit('Click or Drag')
  }

  @HostListener('drop', ['$event'])
  onDrop(event) {
    event.preventDefault()
    event.stopPropagation()

    this.fileOver = false
    const files = event.dataTransfer.files
    if (files.length > 0) {
      this.fileDropped.emit(event)
      this.uploadStatus.emit('Click or Drag')
    }
  }
}
